// Điểm mở rộng của module Chấm công cho khung ứng dụng (FSD.md §2.1, §3.8): Tạo mới, lớp phủ đơn nghỉ, pill thanh trên,
// thời gian thực.
import { qk, type RealtimeBinding } from '@/shared/api';
import { lazyComponent, type OverlayDef } from '@/shared/lib';
import type { CreateItem, TopbarItem } from '@/widgets/app-shell';
import { AttendancePill } from '@/widgets/attendance-pill';

/** Thành phần lớp phủ nạp khi mở (chunk riêng; OverlayHost nạp trước lúc rảnh). */
const LeaveFormOverlay = lazyComponent(() => import('./ui/overlays'), (x) => x.LeaveFormOverlay, 'LeaveFormOverlay');

/** Mục "Tạo mới" ở thanh trên: mở đơn nghỉ / công tác tại trang hiện tại. */
export const createItems: CreateItem[] = [{ label: 'Đơn nghỉ / công tác', icon: 'clock', module: 'attendance', perm: 'attendance.self', to: '.', overlay: ['leave', 'new'] }];

/** ?leave=new — mở từ mọi trang khi module Chấm công hiển thị; thiếu attendance.self ⇒ OverlayHost báo không có quyền. */
export const overlays: OverlayDef[] = [
  { key: 'leave', module: 'attendance', layer: 'modal', perm: 'attendance.self', denied: { title: 'Đơn nghỉ / công tác', text: 'Bạn chưa có quyền gửi đơn nghỉ' }, component: LeaveFormOverlay },
];

/** Pill "Chưa vào ca / Đang làm · HH:mm / Đã ra ca HH:mm" trước chuông (người chấm công của bản thân). */
export const topbarItems: TopbarItem[] = [{ id: 'attendance-pill', module: 'attendance', perm: ['attendance.self'], component: AttendancePill }];

/**
 * attendance: vào/ra ca ({ date }), điều chỉnh ({ month }), đơn nghỉ ({ leaves }), chốt/mở kỳ ({ month, period }), đổi
 * nhân sự / ca ({ roster } / { policy }) — tin không mang ids/staffIds và khung chỉ chuyển `ids` cho keys() ⇒ không lọc theo
 * nội dung được. Làm mới các khoá Chấm công (chỉ truy vấn đang hiển thị tải lại) TRỪ `today`: pill gắn ở mọi trang, mỗi lượt
 * vào ca của bất kỳ ai sẽ khiến mọi người đang mở ứng dụng gọi lại /attendance/me/today, trong khi "hôm nay của tôi" chỉ đổi
 * theo thao tác của chính mình (mutation đã làm mới) hoặc hiếm (duyệt đơn hôm nay, điều chỉnh) — đã có hỏi lại 60 s.
 * Tổng quan tự đăng ký chủ đề này (gộp 5 s) nên không lặp qk.dashboard.all ở đây. Gộp 1 s: giờ vào ca cao điểm.
 */
const REALTIME_KEYS = [
  qk.attendance.policy(),
  qk.attendance.myTimesheet('').slice(0, 2),
  qk.attendance.teamTimesheet('', {}).slice(0, 2),
  qk.attendance.period('').slice(0, 2),
  qk.attendance.day('', '').slice(0, 2),
  qk.attendance.leaves('').slice(0, 2), // gồm pending-count
  qk.attendance.balance(0).slice(0, 2),
  qk.attendance.presence('').slice(0, 2),
] as const;
export const realtime: RealtimeBinding[] = [{ topic: 'attendance', module: 'attendance', keys: () => REALTIME_KEYS, throttleMs: 1000 }];
